// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ap051","textarea":"styles_textarea__3V0Yq"};